import { SelectableRow, StaticRow } from '../types'

type ItemGroup = {
  header: StaticRow | null
  items: SelectableRow[]
}

export const groupItemsByHeaders = (
  rows: Array<StaticRow | SelectableRow>,
): ItemGroup[] => {
  const groups: ItemGroup[] = []
  let currentGroup: ItemGroup = { header: null, items: [] }

  rows.forEach(row => {
    if (row.kind === 'header') {
      if (currentGroup.header || currentGroup.items.length > 0) {
        groups.push(currentGroup)
      }
      currentGroup = { header: row as StaticRow, items: [] }
    } else {
      currentGroup.items.push(row as SelectableRow)
    }
  })

  if (currentGroup.header || currentGroup.items.length > 0) {
    groups.push(currentGroup)
  }

  return groups
}
